import React from 'react';
import { Box, Checkbox, Divider, FormControlLabel, MenuItem, Stack, TextField, Typography } from '@mui/material';

import { MAPPING_FIELDS } from './bankCsvImportUtils';

export default function BankCsvMappingSection({
    headers,
    mapping,
    mappingOptions,
    saveMapping,
    loadingPreview,
    loadingImport,
    onMappingChange,
    onToggleSaveMapping,
}) {
    if (!headers.length && !mapping) {
        return null;
    }

    return (
        <Box>
            <Divider sx={{ my: 2 }} />
            <Stack spacing={2}>
                <Typography variant="subtitle1">Spaltenzuordnung</Typography>
                <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} flexWrap="wrap">
                    {MAPPING_FIELDS.map((field) => (
                        <TextField
                            key={field.key}
                            select
                            size="small"
                            label={`${field.label}${field.required ? ' *' : ''}`}
                            value={mapping?.[field.key] ?? ''}
                            onChange={(event) => onMappingChange(field.key, event.target.value)}
                            disabled={loadingPreview || loadingImport || headers.length === 0}
                            sx={{ minWidth: 220 }}
                        >
                            <MenuItem value="">Nicht zugeordnet</MenuItem>
                            {mappingOptions.map((option) => (
                                <MenuItem key={`${field.key}-${option.value}`} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    ))}
                </Stack>
                <FormControlLabel
                    control={<Checkbox checked={saveMapping} onChange={(event) => onToggleSaveMapping(event.target.checked)} />}
                    label="Mapping speichern"
                />
            </Stack>
        </Box>
    );
}
